import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'polylearn-record-audio',
  templateUrl: './record-audio.component.html',
  styleUrls: ['./record-audio.component.css']
})
export class RecordAudioComponent implements OnInit {
  recorder: any;
  state: 'recording' | 'finished';
  audio: any;

  timer: number;

  minTime: number; // seconds
  @Input() maxTime: number; // seconds

  numberOfRecord = 0;
  @Input() maxRecord: number; // seconds

  @Input() canCancel: boolean = true;
  @Input() canRecord: boolean = true;
  @Output() recorded = new EventEmitter<Blob>();

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    console.log('changes', changes);
    if (
      changes.canRecord.previousValue === true &&
      changes.canRecord.currentValue === false
    ) {
      if (this.state === 'recording') {
        this.cancel();
      }
    }
  }

  public toggle() {
    console.log('toggle');
  }

  recordAudio() {
    const constraints: MediaTrackConstraints = {
      channelCount: 1
      // sampleRate: 16000,
      // sampleSize: 16,
    };

    return new Promise(resolve => {
      navigator.mediaDevices
        .getUserMedia({ audio: constraints })
        .then(stream => {
          const mediaRecorder = new (window as any).MediaRecorder(stream);
          const audioChunks = [];

          mediaRecorder.addEventListener('dataavailable', event => {
            audioChunks.push(event.data);
          });

          const start = () => {
            if (this.maxTime) {
              this.timer = this.maxTime;
            }

            this.numberOfRecord++;

            mediaRecorder.start();
          };

          const stop = () => {
            return new Promise(resolve => {
              mediaRecorder.addEventListener('stop', () => {
                const audioBlob = new Blob(audioChunks, {
                  type: 'audio/mp3'
                });
                const audioUrl = URL.createObjectURL(audioBlob);
                console.log('audioUrl', audioUrl);
                const audio = new Audio(audioUrl);
                const play = () => {
                  audio.play();
                };

                resolve({ audioBlob, audioUrl, play });
              });

              try {
                mediaRecorder.stop();
              } catch (err) {
                console.log(err);
              }
            });
          };

          resolve({ start, stop });
        });
    });
  }

  async play() {
    try {
      this.recorder = await this.recordAudio();
    } catch (err) {
      this.translate.get('record_audio.allow_mic').subscribe(res => {
        window.alert(res);
      });
    }
    this.state = 'recording';
    this.recorder.start();
  }

  async stop() {
    this.audio = await this.recorder.stop();
    this.recorded.emit(this.audio.audioBlob);
    console.log('audio', this.audio.audioBlob);
    console.log('thi', this.audio);
    this.state = 'finished';
  }

  async cancel() {
    this.audio = await this.recorder.stop();
    this.state = null;
    this.recorded.emit(null);
  }

  async playAudio() {
    this.audio.play();
  }

  ngOnDestroy(): void {
    try {
      this.recorder.stop();
    } catch (err) {}
  }

  public onTimerUpdate(time: number) {
    if (time === 0) {
      this.stop();
    }
  }
}
